export default __webpack_public_path__ + "static/media/hudobny-kviz.e29c4a0c.svg";